import { defineMessage } from 'react-intl';

export const bypassKimRatingMessage = defineMessage({
  id: 'detailview.kimRating.bypass.headline.text',
  defaultMessage: 'Unseren Onlineshop bewerten überspringen',
});
